import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ContatoService } from 'src/app/core/services/contato.service';

@Component({
  selector: 'app-lading-contato',
  templateUrl: './landing-contato.component.html',
  styleUrls: ['./landing-contato.component.scss']
})

export class LandingContatoComponent implements OnInit {
  formGroup: FormGroup;

  data: any;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private formBuilder: FormBuilder,
    private contatoService: ContatoService,
    private modalService: NgbModal,
    private gaService: GoogleAnalyticsService
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        )),
        formTelefone: new FormControl('', [Validators.maxLength(18)])
      }
    );
  }

  carregarDados() {
    this.translate.get('LANDING_CONTATO').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
      this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
      this.gaService.pageView(this.router.url);
    });
  }

  onSubmit() {
    let idioma = this.translate.currentLang;
    let pais = 'Brasil';

    if (idioma == 'pt') {
      pais = 'Brasil';
    } else if (idioma == 'es') {
      pais = 'Espanha';
    } else if (idioma == 'en') {
      pais = 'Estados Unidos';
    }

    let telefone = '999999999999';
    if (this.formGroup.get('formTelefone').value != '') {
      telefone = this.formGroup.get('formTelefone').value;
    }

    this.contatoService.cadastrarContato(
      '1',
      this.formGroup.get('formNome').value,
      this.formGroup.get('formEmail').value,
      telefone,
      'LANDING_CONTATO',
      pais,
      'LANDING_CONTATO',
      'Landing Contato',
      'Cadastro efetuado pela tela Landing Contato, entrar em contato para agendar uma demonstração'
    )
      .subscribe(
        res => {
          let message;
          if (res != null) {
            message = res;
          } else {
            message = this.data.CADASTRO.MENSAGEM_SUCESSO;
          }
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = message;
          this.formGroup.reset();
        },
        err => {
          let message;
          if (err != null && err.error != null) {
            message = err.error;
          } else {
            message = this.data.CADASTRO.MENSAGEM_ERRO;
          }
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = message;
          this.formGroup.reset();
        }
      );
  }

}
